var _effectorFileName = "/builds/gmini/front-ui-kit/src/Page404/FlyIcon.tsx";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const FlyIcon = ({
  color = '#353B60',
  ...other
}) => /*#__PURE__*/_jsx("svg", {
  width: "10",
  height: "15",
  viewBox: "0 0 10 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...other,
  children: /*#__PURE__*/_jsxs("g", {
    opacity: "0.9",
    children: [/*#__PURE__*/_jsx("rect", {
      width: "6.23274",
      height: "2.90861",
      rx: "1.45431",
      transform: "matrix(-0.99245 -0.122653 -0.122653 0.99245 7.72316 6.18799)",
      fill: "#353B60"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.49906 9.79987C6.23315 9.5162 5.8762 9.33473 5.49032 9.28704L3.37121 9.02515C2.76202 8.94986 2.16093 9.21646 1.80783 9.71855L0.791647 11.1635C-0.0823426 12.4062 1.03161 14.0734 2.51422 13.7415L3.8621 13.4398C4.17622 13.3695 4.504 13.3919 4.80563 13.5043L6.10823 13.9899C7.75394 14.6033 9.10245 12.5771 7.90131 11.2958L6.49906 9.79987Z",
      fill: "#353B60"
    }), /*#__PURE__*/_jsx("path", {
      d: "M6.77572 5.16706C6.44875 5.37746 6.05836 5.46657 5.67248 5.41888L3.55337 5.15699C2.94418 5.0817 2.42608 4.67679 2.20584 4.10384L1.572 2.45499C1.02686 1.03686 2.51317 -0.308949 3.87038 0.373879L5.10425 0.994654C5.39181 1.13933 5.71519 1.19738 6.03511 1.16178L7.41671 1.00799C9.16224 0.813703 9.97691 3.10717 8.49996 4.05755L6.77572 5.16706Z",
      fill: "#353B60"
    })]
  })
});